export const getTournamentsByStatus = (tournaments = [], status) =>
  tournaments.filter(({ eventStatus }) => eventStatus === status);

export const getTournamentById = (tournaments = [], id) =>
  tournaments.find(({ eventId }) => eventId === id);
